var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded px-4 py-2",class:{ 'bg-yellow-300 text-yellow-900': _vm.type === 'warn' }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }